import React, { forwardRef } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { FormikDatePicker } from 'components/UiKit/FormikFields';
import FormField from 'screens/Equipment/components/FormField';
import FormikCurrencyInput from 'screens/Equipment/components/FormikCurrencyInput';

const PriceAndStatusSection = forwardRef(
  ({ memberRole, memberFinancialAccess }, ref) => {
    const { values } = useFormikContext();
    const { id } = useParams();

    const getServiceList = () => {
      if (
        id !== 'item' &&
        memberRole === 'Full control' &&
        memberFinancialAccess === 'none'
      ) {
        return '';
      }
      return values?.purchasePrice;
    };

    const getCurrentValue = () => {
      if (
        id !== 'item' &&
        memberRole === 'Full control' &&
        memberFinancialAccess === 'none'
      ) {
        return '';
      }
      return values?.currentValue;
    };

    const getDisabled = () => {
      if (
        id !== 'item' &&
        memberRole === 'Full control' &&
        (memberFinancialAccess === 'none' || memberFinancialAccess === 'READ')
      )
        return true;

      return false;
    };

    return (
      <div
        ref={ref}
        className="mt-4"
        data-testid="equipment-item-price-and-status-section"
      >
        <div className="text-2xl font-bold mb-4">History Info</div>
        <div className="flex">
          <div className="w-1/2 mr-16">
            <div className="text-xl font-semibold">Purchase History</div>
            <div className="flex">
              <div className="w-1/2 mr-8">
                <FormField label="Purchase Price" htmlFor="purchasePrice">
                  <FormikCurrencyInput
                    id="purchasePrice"
                    name="purchasePrice"
                    value={getServiceList()}
                    disabled={getDisabled()}
                  />
                </FormField>
              </div>
              <div className="w-1/2">
                <FormField label="Purchase Date" htmlFor="purchasePriceDate">
                  <FormikDatePicker
                    id="purchasePriceDate"
                    name="purchasePriceDate"
                    format="MMM DD, YYYY"
                  />
                </FormField>
              </div>
            </div>
          </div>
          <div className="w-1/2">
            <div className="text-xl font-semibold">Current Value</div>
            <div className="flex">
              <div className="w-1/2 mr-8">
                <FormField label="Current Value" htmlFor="currentValue">
                  <FormikCurrencyInput
                    id="currentValue"
                    name="currentValue"
                    value={getCurrentValue()}
                    disabled={getDisabled()}
                  />
                </FormField>
              </div>
              <div className="w-1/2">
                <FormField
                  label="Current Value Date"
                  htmlFor="currentValueDate"
                >
                  <FormikDatePicker
                    id="currentValueDate"
                    name="currentValueDate"
                    format="MMM DD, YYYY"
                  />
                </FormField>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

PriceAndStatusSection.propTypes = {
  memberRole: PropTypes.string.isRequired,
  memberFinancialAccess: PropTypes.string.isRequired
};

export default PriceAndStatusSection;
